import { useEffect, useState } from "react";
import { useSelector } from "@jti/store";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { buildCommerceBaseData } from "./trackingHelpers";
const useGtmQuantityChange = () => {
    const cart = useSelector((state) => state.cart);
    const order = useSelector((state) => state.order);
    const [cachedCart, setCachedCart] = useState(cart);
    useEffect(() => {
        const { items, itemsPending, id: cartId } = cart;
        const { items: cachedCartItems, id: cachedCartId } = cachedCart;
        // adding to check if order has been placed to not track quantity change after cart is cleared on order completion
        const isOrderCompleted = Boolean(order.orderNumber);
        const shouldTrackItem = cartId && cachedCartId && !itemsPending && !isOrderCompleted;
        const getChangedItem = () => {
            if (!cachedCartItems.length) {
                return items[0];
            }
            if (cachedCartItems.length === items.length) {
                return items.find((item) => cachedCartItems.some((cachedItem) => item.id === cachedItem.id && item.quantity !== cachedItem.quantity));
            }
            return items.find(({ id: itemId }) => cachedCartItems.every(({ id: cachedItemId }) => itemId !== cachedItemId));
        };
        const getCachedItem = (id) => {
            return cachedCartItems.find((item) => item.id === id);
        };
        const getRemovedItem = () => {
            return cachedCartItems.filter(({ id }) => !items.some((item) => item.id === id))[0];
        };
        const trackItemQuantityChange = (trackedItem, cachedItem) => {
            const trackItemQuantity = trackedItem.quantity || 0;
            const cachedItemQuantity = cachedItem?.quantity || 0;
            const changedItemValue = getChangedItem()?.price?.value;
            const event = trackItemQuantity > cachedItemQuantity
                ? TrackingEvents.TrackingCartQuantityAdd
                : TrackingEvents.TrackingCartQuantityRemove;
            const quantityChangeData = {
                ...buildCommerceBaseData(cart, changedItemValue),
            };
            dispatchTrackingEvent(event, quantityChangeData);
        };
        const trackItemsRemove = (removedItem) => {
            const itemsValue = removedItem?.price?.value * removedItem?.quantity;
            dispatchTrackingEvent(TrackingEvents.TrackingCartQuantityRemove, buildCommerceBaseData({
                ...cart,
                items: [removedItem],
            }, itemsValue));
        };
        const removedItem = getRemovedItem();
        if (removedItem && !isOrderCompleted) {
            trackItemsRemove(removedItem);
        }
        if (shouldTrackItem) {
            const trackedItem = getChangedItem();
            if (trackedItem) {
                const cachedItem = getCachedItem(trackedItem.id);
                if (trackedItem.quantity !== cachedItem?.quantity) {
                    trackItemQuantityChange(trackedItem, cachedItem);
                }
            }
        }
        if (cartId) {
            setCachedCart(cart);
        }
    }, [cart.items]);
};
export default useGtmQuantityChange;
//# sourceMappingURL=useGtmQuantityChange.js.map